import CustomersPage from 'src/pages/authenticated/core/customers/CustomersPage';
import { PortalsPage } from 'src/pages/authenticated/portals/PortalsPage';
import { PortalDetailPage } from 'src/pages/authenticated/portals/PortalDetailPage';
import { HomePage } from 'src/pages/authenticated/home/HomePage';
import SalesOrderDraftsPage from 'src/pages/authenticated/core/sales-order-drafts/SalesOrderDraftsPage';
// import SalesOrdersPage from 'src/pages/authenticated/core/sales-orders/SalesOrdersPage';
import SalesOrderPage from 'src/pages/authenticated/core/sales-order/SalesOrderPage';
import SalesOrderDraftPage from 'src/pages/authenticated/core/sales-order-drafts/SalesOrderDraftPage';
import EmailPOMetricsDashboard from 'src/pages/authenticated/core/business-intelligence/EmailPOMetricsDashboard';
import InboundEmailsPage from 'src/pages/authenticated/core/inbound-emails/InboundEmailsPage';
import { InboundEmailRulesPage } from 'src/pages/authenticated/core/inbound-emails/InboundEmailRulesPage';
import DocumentsPage from 'src/pages/authenticated/core/documents/DocumentsPage';
import DocumentDetailPage from 'src/pages/authenticated/core/documents/DocumentDetailPage';

import FamousEDIPage from 'src/pages/authenticated/temp/famous/famous-edi/FamousEDIPage';
import FamousEDIShipmentsPage from 'src/pages/authenticated/temp/famous/famous-edi-shipments/FamousEDIShipmentsPage';
import { Route as FamousEDIShipmentDetailRoute } from 'src/pages/authenticated/temp/famous/famous-edi-shipments/$shipmentId';
// import SubmittedRebatesPage from './pages/authenticated/core/rebates/submitted-rebates/SubmittedRebatesPage';
import RebatesAnalyticsPage from './pages/authenticated/core/rebates/forecasting/RebatesAnalyticsPage';
// import RebatesReconciliationPage from './pages/authenticated/core/rebates/reconciliation/RebatesReconciliationPage';
import SupplierCollectionsPage from './pages/authenticated/core/rebates/supplier-collections/SupplierCollectionsPage';
import RebateAgreementsPage from './pages/authenticated/core/rebates/agreements/RebateAgreementsPage';
import RebateAgreementDetailPage from './pages/authenticated/core/rebates/agreements/RebateAgreementDetailPage';
import SupplierReportedAmountsPage from './pages/authenticated/core/rebates/supplier-reported-amounts/SupplierReportedAmountsPage';
import RebateCalculationAuditPage from './pages/authenticated/core/rebates/calculation-audit/RebateCalculationAuditPage';
import { RebateTierProximityPage } from './pages/authenticated/core/rebates/tier-proximity/RebateTierProximityPage';
import ConvertDataPageWorkflow from './pages/authenticated/core/spreadsheets/ConvertDataPageWorkflow';
import DataUploadRouter from './pages/authenticated/core/spreadsheets/DataUploadRouter';
import ManualRebateCSVUpload from './pages/authenticated/core/spreadsheets/ManualRebateCSVUpload';
import EmailUploadQueuePage from './pages/authenticated/core/spreadsheets/EmailUploadQueuePage';
import DemoResultsPage from './pages/authenticated/core/spreadsheets/DemoResultsPage';
import DivisionsPage from './pages/authenticated/core/divisions/DivisionsPage';
import DivisionDetailPage from './pages/authenticated/core/divisions/DivisionDetailPage';
import { PriceQuoteSheetDashboard } from './pages/authenticated/core/procurement/price-sheet-dashboard/PriceQuoteSheetDashboard';
import { Route as PriceQuoteSheetDashboardDetailRoute } from './pages/authenticated/core/procurement/price-sheet-dashboard/detail.$quoteSheetId';
import { PriceQuoteSheetInboxPage } from './pages/authenticated/core/procurement/price-sheet-inbox/PriceQuoteSheetInboxPage';
import { Route as PriceQuoteSheetInboxDetailRoute } from './pages/authenticated/core/procurement/price-sheet-inbox/$quoteSheetId';
import { FeatureFlagsPage } from './pages/authenticated/settings/FeatureFlagsPage';
import { HistoricalImportPage } from './pages/authenticated/admin/historical-import/HistoricalImportPage';
import RexelMonitoringPage from './pages/authenticated/rexel/RexelMonitoringPage';
import { ShipAndDebitDashboard } from './pages/authenticated/core/ship-and-debit/dashboard/ShipAndDebitDashboard';
import { VDMsPage } from './pages/authenticated/core/ship-and-debit/vdms/VDMsPage';
import { ShipAndDebit844sPage } from './pages/authenticated/core/ship-and-debit/844s/ShipAndDebit844sPage';
import { ProcurementDemoDashboard } from './pages/authenticated/procurement-demo/dashboard/ProcurementDemoDashboard';
import { SuppliersPage as ProcurementDemoSuppliersPage } from './pages/authenticated/procurement-demo/suppliers/SuppliersPage';
import { ItemsPage as ProcurementDemoItemsPage } from './pages/authenticated/procurement-demo/items/ItemsPage';
import { SpendingAnalyticsPage as ProcurementDemoSpendingAnalyticsPage } from './pages/authenticated/procurement-demo/spending-analytics/SpendingAnalyticsPage';
import { PurchaseOrdersPage as ProcurementDemoPurchaseOrdersPage } from './pages/authenticated/procurement-demo/purchase-orders/PurchaseOrdersPage';
import { InventoryPage as ProcurementDemoInventoryPage } from './pages/authenticated/procurement-demo/inventory/InventoryPage';
import { AIWorkflowsPage as ProcurementDemoAgentsPage } from './pages/authenticated/procurement-demo/ai-workflows/AIWorkflowsPage';
import { AIWorkflowDetailsPage as ProcurementDemoAgentDetailsPage } from './pages/authenticated/procurement-demo/ai-workflows/AIWorkflowDetailsPage';
import { ProcurementPlanPage as ProcurementDemoPlanPage } from './pages/authenticated/procurement-demo/procurement-plan/ProcurementPlanPage';
import { Route as memoryBankNotesRoute } from './pages/authenticated/memory-bank-notes';
import { Route as integrationsListRoute } from './pages/authenticated/integrations';
import { Route as integrationDetailRoute } from './pages/authenticated/integrations/$integrationKey';
import { WorkflowTemplatesPage } from './pages/authenticated/workflows/WorkflowTemplatesPage';
import { WorkflowsPage } from './pages/authenticated/workflows/WorkflowsPage';
import { WorkflowPlaygroundPage } from './pages/authenticated/workflows/playground/WorkflowPlaygroundPage';
import { WorkflowDefinitionsTab } from './pages/authenticated/workflows/WorkflowDefinitionsTab';
import { WorkflowDefinitionLayoutPage } from './pages/authenticated/workflows/WorkflowDefinitionLayoutPage';
import { WorkflowDefinitionOverviewTab } from './pages/authenticated/workflows/WorkflowDefinitionOverviewTab';
import { WorkflowDefinitionStepsTab } from './pages/authenticated/workflows/WorkflowDefinitionStepsTab';
import { WorkflowDefinitionRunsTab } from './pages/authenticated/workflows/WorkflowDefinitionRunsTab';
import { AgentBuildersPage } from './pages/authenticated/agent-builders/AgentBuildersPage';
import { AgentBuilderDefinitionsTab } from './pages/authenticated/agent-builders/AgentBuilderDefinitionsTab';
import { AgentBuilderDetailLayoutPage } from './pages/authenticated/agent-builders/AgentBuilderDetailLayoutPage';
import {
  ReceiptIcon,
  ClipboardTextIcon,
  TagIcon,
  ArrowCounterClockwiseIcon,
  TruckIcon,
  PresentationChartIcon,
  BuildingIcon,
  BuildingsIcon,
  TableIcon,
  CurrencyDollarIcon,
  FileTextIcon,
  ShoppingCartIcon,
  BankIcon,
  TrendUpIcon,
  TargetIcon,
  ChartBarIcon,
  DownloadIcon,
  ClockCounterClockwiseIcon,
  ArrowsLeftRightIcon,
  FolderIcon,
  MonitorIcon,
  ShieldWarningIcon,
  GlobeIcon,
  SquaresFourIcon,
  UsersIcon,
  PackageIcon,
  CubeIcon,
  RobotIcon,
} from '@phosphor-icons/react';
import paths from 'src/paths';
import { slugify } from 'src/utils/strings';
import { Permission, Action, Subject } from '@erp/authz';

import { Route as rootRoute } from 'src/pages/__root';
import { createRoute, redirect } from '@tanstack/react-router';
import StatusPage from '@/pages/(unauthenticated)/status/StatusPage';
import { Route as loginRoute } from 'src/pages/(unauthenticated)/login';
import { Route as workosCallbackRoute } from 'src/pages/(unauthenticated)/workos-callback';
import { Route as indexRoute } from 'src/pages/index';
import { PortalInviteAcceptPage } from 'src/pages/portal/PortalInviteAcceptPage';
import { PortalLoginPage } from 'src/pages/portal/PortalLoginPage';
import { GlobalPortalLoginPage } from 'src/pages/portal/GlobalPortalLoginPage';
import { PortalWelcomePage } from 'src/pages/portal/PortalWelcomePage';
import PortalContentPage from 'src/pages/portal/PortalContentPage';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from 'src/pages/authenticated/route';
import SettingsOrganizationPage from './pages/authenticated/settings/organization/SettingsOrganizationPage';
import { z } from 'zod';
import DebtorsReportPage from './pages/authenticated/core/rebates/debitors/DebtorsReportPage';
import RebateReportsIndexPage from './pages/authenticated/core/rebates/reports/RebateReportsIndexPage';
import DivisionRebateSummaryPage from './pages/authenticated/core/rebates/reports/DivisionRebateSummaryPage';
import SupplierTagReportPage from './pages/authenticated/core/rebates/reports/SupplierTagReportPage';
import DailyEarningsPYEPage from './pages/authenticated/core/rebates/reports/DailyEarningsPYEPage';
import MonthlyTrendingPage from './pages/authenticated/core/rebates/reports/MonthlyTrendingPage';
import SupplierPaymentTermsPage from './pages/authenticated/core/rebates/reports/SupplierPaymentTermsPage';
import ProfitabilityReportPage from './pages/authenticated/core/rebates/reports/ProfitabilityReportPage';
import TempReportPage from './pages/authenticated/core/rebates/reports/TempReportPage';
import RebateDataExportPage from './pages/authenticated/core/rebates/exports/RebateDataExportPage';
import { ProductModule } from './hooks/organization-config/useOrganizationEnabledModules';
import QAPage from './pages/qa/QAPage';
import AzureOauthFlowCallback from './pages/authenticated/AzureOauthFlowCallback';
import config from 'src/config';

import { InvoiceDemosPage } from 'src/pages/accounts-payable/invoice-demos';
import { InvoicesPage } from './pages/authenticated/accounts-payable/invoices/InvoicesPage';
import PaymentsPage from './pages/authenticated/accounts-payable/payments/PaymentsPage';
import { Route as InvoiceDetailRoute } from './pages/authenticated/accounts-payable/invoices/$invoiceId';
import { PurchaseOrdersPage } from './pages/authenticated/accounts-payable/purchase-orders/PurchaseOrdersPage';
import { Route as PurchaseOrderDetailRoute } from './pages/authenticated/accounts-payable/purchase-orders/$purchaseOrderId';
import { Route as PaymentDetailRoute } from './pages/authenticated/accounts-payable/payments/$paymentId';
import CompaniesPage from './pages/authenticated/core/companies/CompaniesPage';
import CompanyDetailPage from './pages/authenticated/core/companies/CompanyDetailPage';
import { CustomerProductMatchesPage } from './pages/authenticated/accounts-receivable/customer-product-matches/CustomerProductMatchesPage';
import { AROverviewPage } from './pages/authenticated/accounts-receivable/overview/AROverviewPage';
import { ARCollectionsPage } from './pages/authenticated/accounts-receivable/collections/ARCollectionsPage';
import { ARInvoicesPage } from './pages/authenticated/accounts-receivable/invoices/ARInvoicesPage';
import { ARAgingReportPage } from './pages/authenticated/accounts-receivable/aging-report/ARAgingReportPage';
import { ARReconciliationPage } from './pages/authenticated/accounts-receivable/reconciliation/ARReconciliationPage';
import { CustomerCollectionsPage } from './pages/authenticated/accounts-receivable/collections/CustomerCollectionsPage';
import { DiscountsPage } from './pages/authenticated/core/discounts/DiscountsPage';
import SharedReportPage from './pages/authenticated/shared/SharedReportPage';
import { SharedLinksPage } from './pages/authenticated/shared-links/SharedLinksPage';
import { ExtractionViewerPage } from './pages/authenticated/core/sales-order-drafts/extraction-viewer/ExtractionViewerPage';
import { AllocationsPage } from './pages/authenticated/core/allocations/AllocationsPage';

export interface RouteItem {
  type: 'collapse' | 'title' | 'divider';
  name?: string; // Optional because 'divider' type doesn't have a name
  key: string;
  route?: string; // Optional if the route is for external links or dividers TODO: require this to be a valid route
  href?: string; // For external links
  icon?: React.ReactNode; // Icon used in the Sidenav
  component?: React.ReactNode; // Component to render when the route is active
  moduleNamesAnyOf?: ProductModule[]; // some of these modules must be enabled
  moduleNamesAllOf?: ProductModule[]; // all these modules must be enabled
  /**
   * User must have at least one of these permissions to see this route.
   * Similar to moduleNamesAnyOf but for entity-level permissions.
   */
  permissionsAnyOf?: Permission[];
  /**
   * User must have all of these permissions to see this route.
   * Similar to moduleNamesAllOf but for entity-level permissions.
   */
  permissionsAllOf?: Permission[];
  title?: string; // For 'title' type items
  noCollapse?: boolean; // If the item should not be collapsible
  collapse?: RouteItem[]; // Nested routes for collapsible items
  hidden?: boolean; // Add this property to hide from sidebar
  adminOnly?: boolean; // Only show this route to admin users
  badge?: {
    color: 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';
    label: string;
  };
}

export type RouteItems = RouteItem[];

// Original routes array for legacy compatibility
const routes: RouteItems = [
  {
    type: 'title',
    title: 'Sales',
    key: 'title-sales',
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Customers',
    key: 'customers',
    route: paths.authenticated.customers,
    icon: <BuildingsIcon className="h-4 w-4" weight="fill" />,
    component: <CustomersPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Portals',
    key: 'portals',
    route: paths.authenticated.portals,
    icon: <GlobeIcon className="h-4 w-4" weight="fill" />,
    component: <PortalsPage />,
    noCollapse: true,
    hidden: true,
  },
  // {
  //   type: 'collapse',
  //   name: 'Sales Order Drafts',
  //   key: 'purchase-orders',
  //   route: paths.authenticated.purchaseOrders,
  //   icon: <Icon fontSize="medium">shopping_cart_checkout</Icon>,
  //   component: <SalesOrderDraftsPage />,
  //   noCollapse: true,
  //   moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  // },
  {
    type: 'collapse',
    name: 'Sales Orders',
    key: 'Sales Orders',
    route: paths.authenticated.salesOrders,
    icon: <ReceiptIcon className="h-4 w-4" weight="fill" />,
    component: <SalesOrderDraftsPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Product Matches',
    key: 'customer-product-matches',
    route: paths.authenticated.customerProductMatches,
    icon: <ClipboardTextIcon className="h-4 w-4" weight="fill" />,
    component: <CustomerProductMatchesPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Discounts',
    key: 'discounts',
    route: paths.authenticated.discounts,
    icon: <TagIcon className="h-4 w-4" weight="fill" />,
    component: <DiscountsPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse' as const,
    name: 'Metrics',
    key: 'email-po-metrics',
    route: paths.authenticated.emailPOMetrics,
    icon: <PresentationChartIcon className="h-4 w-4" weight="fill" />,
    component: <EmailPOMetricsDashboard />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'title',
    title: 'Accounts Receivable',
    key: 'title-accounts-receivable',
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Overview',
    key: 'ar-overview',
    route: paths.authenticated.accountsReceivable.overview,
    icon: <SquaresFourIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Invoices',
    key: 'ar-invoices',
    route: paths.authenticated.accountsReceivable.invoices,
    icon: <FileTextIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Collections',
    key: 'ar-collections',
    route: paths.authenticated.accountsReceivable.collections,
    icon: <CurrencyDollarIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Aging Report',
    key: 'ar-aging-report',
    route: paths.authenticated.accountsReceivable.agingReport,
    icon: <ChartBarIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    hidden: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Reconciliation',
    key: 'ar-reconciliation',
    route: paths.authenticated.accountsReceivable.reconciliation,
    icon: <ArrowsLeftRightIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Sales Order',
    key: 'Sales Order',
    route: paths.authenticated.salesOrder,
    icon: <ReceiptIcon className="h-4 w-4" weight="fill" />,
    component: <SalesOrderPage />,
    noCollapse: true,
    hidden: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Famous EDI (Invoices)',
    key: 'Famous EDI',
    route: paths.authenticated.famousEDI,
    icon: <ArrowCounterClockwiseIcon className="h-4 w-4" weight="fill" />,
    component: <FamousEDIPage />,
    noCollapse: true,
    moduleNamesAllOf: [
      ProductModule.FAMOUS_INTEGRATION,
      ProductModule.ORDERFUL_EDI,
    ],
  },
  {
    type: 'collapse',
    name: 'Famous EDI (Shipments)',
    key: 'Famous EDI Shipments',
    route: paths.authenticated.famousEDIShipments,
    icon: <TruckIcon className="h-4 w-4" weight="fill" />,
    component: <FamousEDIShipmentsPage />,
    noCollapse: true,
    moduleNamesAllOf: [
      ProductModule.FAMOUS_INTEGRATION,
      ProductModule.ORDERFUL_EDI,
    ],
  },

  {
    type: 'title',
    title: 'Organization',
    key: 'title-organization',
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Divisions',
    key: 'divisions',
    route: paths.authenticated.divisions,
    icon: <BuildingIcon className="h-4 w-4" weight="fill" />,
    component: <DivisionsPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse' as const,
    name: 'Companies',
    key: 'companies',
    route: paths.authenticated.companies,
    icon: <BuildingsIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [
      ProductModule.REBATES,
      // ProductModule.PROCUREMENT,
    ],
  },

  {
    type: 'title',
    title: 'Procurement',
    key: 'title-procurement',
    moduleNamesAnyOf: [ProductModule.PROCUREMENT],
  },

  {
    type: 'collapse' as const,
    name: 'Price Sheet Dashboard',
    key: 'procurement-price-sheet-dashboard',
    route: paths.authenticated.procurement.priceSheetDashboard,
    icon: <TableIcon className="h-4 w-4" weight="fill" />,
    component: <PriceQuoteSheetDashboard />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT],
  },

  {
    type: 'collapse' as const,
    name: 'Price Sheets',
    key: 'procurement-price-sheet',
    route: paths.authenticated.procurement.priceSheetInbox,
    icon: <CurrencyDollarIcon className="h-4 w-4" weight="fill" />,
    component: <PriceQuoteSheetInboxPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT],
  },
  {
    type: 'title',
    title: 'Accounts Payable',
    key: 'title-accounts-payable',
    moduleNamesAnyOf: [ProductModule.AP_INVOICING],
  },
  {
    type: 'collapse' as const,
    name: 'Invoices',
    key: 'ap-invoices',
    route: paths.authenticated.accountsPayable.invoices,
    icon: <FileTextIcon className="h-4 w-4" weight="fill" />,
    component: <InvoicesPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.AP_INVOICING],
    permissionsAnyOf: [{ action: Action.Read, subject: Subject.APInvoice }],
  },
  {
    type: 'collapse' as const,
    name: 'Purchase Orders',
    key: 'ap-purchase-orders',
    route: paths.authenticated.accountsPayable.purchaseOrders,
    icon: <ShoppingCartIcon className="h-4 w-4" weight="fill" />,
    component: <PurchaseOrdersPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.AP_INVOICING],
    permissionsAnyOf: [{ action: Action.Read, subject: Subject.PurchaseOrder }],
  },
  {
    type: 'collapse' as const,
    name: 'Payments & Transactions',
    key: 'ap-payments',
    route: paths.authenticated.accountsPayable.payments,
    icon: <BankIcon className="h-4 w-4" weight="fill" />,
    component: <PaymentsPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.AP_INVOICING],
    permissionsAnyOf: [
      { action: Action.Read, subject: Subject.APInvoicePayment },
    ],
  },
  {
    type: 'title',
    title: 'Rebates',
    key: 'title-rebates',
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Agreement Detail',
    key: 'rebate-agreement-detail',
    route: paths.authenticated.rebates.agreement,
    component: <RebateAgreementDetailPage />,
    hidden: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },

  {
    type: 'collapse',
    name: 'Upload Data',
    key: 'rebate-upload-data',
    route: paths.authenticated.rebates.uploadData,
    icon: <ArrowCounterClockwiseIcon className="h-4 w-4" weight="fill" />,
    component: <DataUploadRouter />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Agreements',
    key: 'rebate-agreements',
    route: paths.authenticated.rebates.agreements,
    icon: <FileTextIcon className="h-4 w-4" weight="fill" />,
    component: <RebateAgreementsPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Analytics',
    key: 'rebate-analytics',
    route: paths.authenticated.rebates.analytics,
    icon: <TrendUpIcon className="h-4 w-4" weight="fill" />,
    component: <RebatesAnalyticsPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Debtors Report',
    key: 'rebate-debitors',
    route: paths.authenticated.rebates.debitors,
    icon: <BankIcon className="h-4 w-4" weight="fill" />,
    component: <DebtorsReportPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Reports',
    key: 'rebate-reports',
    route: paths.authenticated.rebates.reports,
    icon: <ChartBarIcon className="h-4 w-4" weight="fill" />,
    component: <RebateReportsIndexPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Data Export',
    key: 'rebate-data-export',
    route: paths.authenticated.rebates.dataExport,
    icon: <DownloadIcon className="h-4 w-4" weight="fill" />,
    component: <RebateDataExportPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Historical Data Import',
    key: 'historical-import',
    route: paths.authenticated.historicalImport,
    icon: <ClockCounterClockwiseIcon className="h-4 w-4" weight="fill" />,
    component: <HistoricalImportPage />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  // {
  //   type: 'collapse',
  //   name: 'Reconciliation',
  //   key: 'rebate-reconciliation',
  //   route: paths.authenticated.rebates.reconciliation,
  //   icon: <Icon fontSize="medium">compare_arrows</Icon>,
  //   component: <RebatesReconciliationPage />,
  //   noCollapse: true,
  //   moduleNames: ['rebates'],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Reporting',
  //   key: 'rebate-reporting',
  //   route: paths.authenticated.rebates.reporting,
  //   icon: <Icon fontSize="medium">bar_chart</Icon>,
  //   component: <ComingSoonPage title="Rebates Reporting" />,
  //   noCollapse: true,
  //   moduleNames: ['rebates'],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Submissions',
  //   key: 'submissions',
  //   route: paths.authenticated.rebates.submitted,
  //   icon: <Icon fontSize="medium">forward_to_inbox</Icon>,
  //   component: <SubmittedRebatesPage />,
  //   noCollapse: true,
  //   moduleNames: ['rebates'],
  // },
  {
    type: 'collapse',
    name: 'Supplier Collections',
    key: 'supplier-collections',
    route: paths.authenticated.rebates.supplierCollections,
    component: <SupplierCollectionsPage />,
    hidden: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },
  {
    type: 'collapse',
    name: 'Supplier Reported Amounts',
    key: 'supplier-reported-amounts',
    route: paths.authenticated.rebates.supplierReportedAmounts,
    component: <SupplierReportedAmountsPage />,
    hidden: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },

  {
    type: 'title',
    title: 'Ship and Debit',
    key: 'title-ship-and-debit',
    moduleNamesAnyOf: [ProductModule.SHIP_AND_DEBIT],
  },
  {
    type: 'collapse',
    name: 'Pending Transactions',
    key: 'ship-and-debit-dashboard',
    route: paths.authenticated.shipAndDebit.dashboard,
    component: <ShipAndDebitDashboard />,
    icon: <ArrowsLeftRightIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.SHIP_AND_DEBIT],
  },
  {
    type: 'collapse',
    name: '844s & 849s',
    key: 'ship-and-debit-844-and-849',
    route: paths.authenticated.shipAndDebit.transactions,
    component: <ShipAndDebit844sPage />,
    icon: <ArrowsLeftRightIcon size={20} weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.SHIP_AND_DEBIT],
  },
  {
    type: 'collapse',
    name: 'VDMs',
    key: 'ship-and-debit-vdms',
    route: paths.authenticated.shipAndDebit.vdm,
    component: <VDMsPage />,
    icon: <ReceiptIcon size={20} weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.SHIP_AND_DEBIT],
  },

  // Planning
  {
    type: 'title',
    title: 'Planning',
    key: 'title-planning',
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },
  {
    type: 'collapse',
    name: 'Allocations',
    key: 'allocations',
    route: paths.authenticated.allocations,
    component: <AllocationsPage />,
    icon: <SquaresFourIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.ORDER_MANAGEMENT],
  },

  // Procurement Demo Module
  {
    type: 'title',
    title: 'Procurement',
    key: 'title-procurement-demo',
    moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  },
  // Dashboard hidden for now
  // {
  //   type: 'collapse',
  //   name: 'Dashboard',
  //   key: 'procurement-demo-dashboard',
  //   route: paths.authenticated.procurementDemo.dashboard,
  //   component: <ProcurementDemoDashboard />,
  //   icon: <SquaresFourIcon className="h-4 w-4" weight="fill" />,
  //   noCollapse: true,
  //   moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  // },
  {
    type: 'collapse',
    name: 'Procurement Agents',
    key: 'procurement-demo-agents',
    route: paths.authenticated.procurementDemo.aiWorkflows,
    component: <ProcurementDemoAgentsPage />,
    icon: <RobotIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  },
  {
    type: 'collapse',
    name: 'Inventory Planning',
    key: 'procurement-demo-inventory',
    route: paths.authenticated.procurementDemo.inventory,
    component: <ProcurementDemoInventoryPage />,
    icon: <CubeIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  },
  {
    type: 'collapse',
    name: 'Suppliers',
    key: 'procurement-demo-suppliers',
    route: paths.authenticated.procurementDemo.suppliers,
    component: <ProcurementDemoSuppliersPage />,
    icon: <UsersIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  },
  {
    type: 'collapse',
    name: 'Supplier Catalog',
    key: 'procurement-demo-items',
    route: paths.authenticated.procurementDemo.items,
    component: <ProcurementDemoItemsPage />,
    icon: <PackageIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  },
  {
    type: 'collapse',
    name: 'Spending Analytics',
    key: 'procurement-demo-spending-analytics',
    route: paths.authenticated.procurementDemo.spendingAnalytics,
    component: <ProcurementDemoSpendingAnalyticsPage />,
    icon: <TrendUpIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  },
  {
    type: 'collapse',
    name: 'Purchase Orders',
    key: 'procurement-demo-purchase-orders',
    route: paths.authenticated.procurementDemo.purchaseOrders,
    component: <ProcurementDemoPurchaseOrdersPage />,
    icon: <ShoppingCartIcon className="h-4 w-4" weight="fill" />,
    noCollapse: true,
    moduleNamesAnyOf: [ProductModule.PROCUREMENT_DEMO],
  },

  {
    type: 'collapse' as const,
    name: 'Inbound Emails',
    key: 'inbound-emails',
    route: paths.authenticated.inboundEmails,
    component: <InboundEmailsPage />,
    hidden: true,
  },
  {
    type: 'collapse' as const,
    name: 'Documents',
    key: 'documents',
    route: paths.authenticated.documents,
    icon: <FolderIcon className="h-4 w-4" weight="fill" />,
    component: <DocumentsPage />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: 'collapse' as const,
    name: 'Document Detail',
    key: 'document-detail',
    route: paths.authenticated.document,
    component: <DocumentDetailPage />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: 'collapse',
    name: 'Division Detail',
    key: 'division-detail',
    route: paths.authenticated.division,
    component: <DivisionDetailPage />,
    hidden: true,
    moduleNamesAnyOf: [ProductModule.REBATES],
  },

  // MONITORING
  {
    type: 'collapse',
    name: 'Rexel Monitor',
    key: 'rexel-monitoring',
    route: paths.authenticated.rexelMonitoring,
    icon: <MonitorIcon className="h-4 w-4" weight="fill" />,
    component: <RexelMonitoringPage />,
    noCollapse: true,
    hidden: true,
  },

  // DEBUG/DEV
  {
    type: 'collapse',
    name: 'Feature Flags',
    key: 'feature-flags',
    route: paths.authenticated.featureFlags,
    component: <FeatureFlagsPage />,
    hidden: true,
  },
];

// tanstack router routes
// Create individual routes

// TODO remove this demo route
const invoiceDemosRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/invoice-demos',
  component: InvoiceDemosPage,
  loader: () => ({
    crumb: 'Invoice Demos',
  }),
});

const customersRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/customers',
  component: CustomersPage,
  loader: () => ({
    crumb: 'Customers',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
  validateSearch: z.object({
    customerId: z.string().optional(),
    tab: z.string().optional(),
  }),
});

const portalsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/portals',
  component: PortalsPage,
  loader: () => ({
    crumb: 'Portals',
  }),
});

const portalDetailRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/portals/$portalId',
  component: PortalDetailPage,
  loader: () => ({
    crumb: 'Portal',
  }),
});

const salesOrdersRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders',
  component: SalesOrderDraftsPage,
  loader: () => ({
    crumb: 'Sales Orders',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
  validateSearch: z.object({
    salesOrderId: z.string().optional(),
    isReadyForApproval: z.enum(['true', 'false']).optional(),
    status: z.string().optional(),
  }),
});

const salesOrderRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders/$salesOrderId',
  component: SalesOrderPage,
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

const salesOrderDraftRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders/draft/$draftId',
  component: SalesOrderDraftPage,
  loader: () => ({
    crumb: 'Sales Order Draft',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

const salesOrderDraftExtractionViewerRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-order-drafts/$draftId/extraction-viewer',
  component: ExtractionViewerPage,
  loader: () => ({
    fullscreen: true, // Hide sidebar and header for immersive document viewing
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

const suppliersRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/suppliers',
  component: CompaniesPage,
  loader: () => ({
    crumb: 'Suppliers',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES, ProductModule.PROCUREMENT],
    });
  },
});

const supplierDetailRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/suppliers/$id',
  component: CompanyDetailPage,
  loader: () => ({
    crumb: `Supplier`,
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES, ProductModule.PROCUREMENT],
    });
  },
});

const companiesRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/companies',
  component: CompaniesPage,
  loader: () => ({
    crumb: 'Companies',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES, ProductModule.PROCUREMENT],
    });
  },
});

const companyDetailRoute = createRoute({
  getParentRoute: () => companiesRoute,
  path: '$id',
  component: CompanyDetailPage,
  loader: async ({ params, context }) => {
    // Fetch company data for breadcrumb using queryClient for caching
    const { queryClient } = context;
    const queryKey = [`core/companies/${params.id}`];

    try {
      // Use queryClient.fetchQuery to leverage caching
      const response = await queryClient.fetchQuery({
        queryKey,
        queryFn: async () => {
          const fetchResponse = await fetch(
            `${config.apiBaseUrl}/core/companies/${params.id}`,
            { credentials: 'include' },
          );

          if (!fetchResponse.ok) {
            throw new Error('Failed to fetch company');
          }

          const data = await fetchResponse.json();
          return data.data;
        },
      });

      return {
        crumb: response?.company?.name || 'Company',
      };
    } catch (error) {
      // Silently handle error - fallback to default
    }

    return {
      crumb: 'Company',
    };
  },
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES, ProductModule.PROCUREMENT],
    });
  },
});

const rebateSupplierDetailRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/suppliers/$id',
  component: () => <CompanyDetailPage module="rebates" />,
  loader: () => ({
    crumb: `Rebate Supplier`,
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const emailPOMetricsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/email-po-metrics',
  component: EmailPOMetricsDashboard,
  loader: () => ({
    crumb: 'Metrics',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
  validateSearch: z.object({
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    groupBy: z.enum(['daily', 'weekly', 'monthly']).prefault('daily'),
    from: z.string().optional(),
    to: z.string().optional(),
  }),
});

const famousEDIRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/famous-edi',
  component: FamousEDIPage,
  loader: () => ({
    crumb: 'Famous EDI',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      allOf: [ProductModule.ORDERFUL_EDI, ProductModule.FAMOUS_INTEGRATION],
    });
  },
});

const famousEDIShipmentsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/famous-edi-shipments',
  component: FamousEDIShipmentsPage,
  loader: () => ({
    crumb: 'Famous EDI Shipments',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      allOf: [ProductModule.ORDERFUL_EDI, ProductModule.FAMOUS_INTEGRATION],
    });
  },
});

const famousEDIShipmentDetailRoute = createRoute({
  getParentRoute: () => famousEDIShipmentsRoute,
  path: '/$shipmentId',
  component: FamousEDIShipmentDetailRoute,
});

// const rebatesSubmittedRoute = createRoute({
//   getParentRoute: () => pathlessAuthenticatedRoute,
//   path: '/rebates/submitted',
//   component: SubmittedRebatesPage,
// });

const rebatesForecastingRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/analytics',
  component: RebatesAnalyticsPage,
  loader: () => ({
    crumb: 'Analytics',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
  validateSearch: z.object({
    cumulative: z.boolean().optional(),
    ruleTagIds: z.array(z.string()).optional(),
    ruleType: z.array(z.enum(['conditional', 'non-conditional'])).optional(),
    agreementTagIds: z.array(z.string()).optional(),
    supplierTagIds: z.array(z.string()).optional(),
    agreementIds: z.array(z.string()).optional(),
    supplierIds: z.array(z.string()).optional(),
    divisionIds: z.array(z.string()).optional(),
    year: z.number().optional(),
    visibleLines: z.array(z.string()).optional(),
    primaryLine: z.string().optional(),
  }),
});

const rebatesDebtorsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/debtors',
  component: DebtorsReportPage,
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
  loader: () => ({
    crumb: 'Debtors Report',
  }),
});

const rebatesTierProximityRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/tier-proximity',
  component: RebateTierProximityPage,
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
  loader: () => ({
    crumb: 'Tier Proximity',
  }),
});

// const rebatesReconciliationRoute = createRoute({
//   getParentRoute: () => pathlessAuthenticatedRoute,
//   path: '/rebates/reconciliation',
//   component: RebatesReconciliationPage,
// });

const rebatesAgreementsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/agreements',
  component: RebateAgreementsPage,
  loader: () => ({
    crumb: 'Agreements',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
  validateSearch: z.object({
    search: z.string().optional(),
    year: z.number().optional(),
    showClosed: z.boolean().optional(),
  }),
});

// Layout route for agreement detail - handles shared loader and auth
const rebatesAgreementLayoutRoute = createRoute({
  getParentRoute: () => rebatesAgreementsRoute,
  path: '$id',
  beforeLoad: async ({ context, params }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });

    // Fetch agreement data and extend context for child routes
    const { queryClient } = context;
    const queryKey = [`rebates/agreements/${params.id}`];

    try {
      const agreement = await queryClient.fetchQuery({
        queryKey,
        queryFn: async () => {
          const response = await fetch(
            `${config.apiBaseUrl}/rebates/agreements/${params.id}`,
            { credentials: 'include' },
          );

          if (!response.ok) {
            throw new Error('Failed to fetch agreement');
          }

          const data = await response.json();
          return data.data;
        },
      });

      return { agreement };
    } catch {
      return { agreement: null };
    }
  },
  loader: ({ context }) => {
    // Use agreement from beforeLoad context for breadcrumb
    const { agreement } = context as { agreement?: { name?: string } };
    return {
      crumb: agreement?.name || 'Agreement Detail',
    };
  },
  validateSearch: z.object({
    version: z.string().optional(),
  }),
});

// Index route - matches /rebates/agreements/{id} (no slug)
// Redirects to canonical URL with slug for better URLs
const rebatesAgreementIndexRoute = createRoute({
  getParentRoute: () => rebatesAgreementLayoutRoute,
  path: '/',
  beforeLoad: ({ context, params, search }) => {
    // Get agreement from parent's beforeLoad context
    const { agreement } = context as { agreement?: { name?: string } };

    if (agreement?.name) {
      // Redirect to canonical URL with slug
      const slug = slugify(agreement.name);
      if (slug) {
        throw redirect({
          to: '/rebates/agreements/$id/$slug',
          params: { id: params.id, slug },
          search,
          replace: true,
        });
      }
    }
  },
  component: RebateAgreementDetailPage,
});

// Slug route - matches /rebates/agreements/{id}/{slug}
// Static paths like 'create-version' and 'audit' take priority over this dynamic route
const rebatesAgreementSlugRoute = createRoute({
  getParentRoute: () => rebatesAgreementLayoutRoute,
  path: '$slug',
  component: RebateAgreementDetailPage,
});

import RebateAgreementCreateVersionPage from './pages/authenticated/core/rebates/agreements/RebateAgreementCreateVersionPage';
import { orpc } from './api/rpc/client';

const rebatesAgreementCreateVersionRoute = createRoute({
  getParentRoute: () => rebatesAgreementLayoutRoute,
  path: 'create-version',
  component: RebateAgreementCreateVersionPage,
  loader: () => ({
    crumb: 'Create New Version',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebateCalculationAuditRoute = createRoute({
  getParentRoute: () => rebatesAgreementLayoutRoute,
  path: 'audit',
  component: RebateCalculationAuditPage,
  loader: () => ({
    crumb: 'Calculation Audit',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
  validateSearch: z.object({
    date: z.string().optional(),
    calculationType: z.enum(['estimate', 'prediction']).optional(),
  }),
});

const rebatesSupplierCollectionsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/supplier-collections/$supplierId',
  component: SupplierCollectionsPage,
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesSupplierReportedAmountsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/supplier-reported-amounts/$supplierId',
  component: SupplierReportedAmountsPage,
  loader: () => ({
    crumb: 'Supplier Reported Amounts',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesUploadDataRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/upload-data',
  component: DataUploadRouter,
  loader: () => ({
    crumb: 'Upload Data',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesUploadDataAIRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/upload-data/ai',
  component: ConvertDataPageWorkflow,
  loader: () => ({
    crumb: 'AI-Powered Transform',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
  validateSearch: z.object({
    pendingUploadId: z.string().uuid().optional(),
  }),
});

const rebatesUploadDataManualRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/upload-data/manual',
  component: ManualRebateCSVUpload,
  loader: () => ({
    crumb: 'Manual Upload',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesUploadDataEmailQueueRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/upload-data/email-queue',
  component: EmailUploadQueuePage,
  loader: () => ({
    crumb: 'Email Queue',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesUploadDataDemoResultsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/upload-data/demo-results/$uploadId',
  component: DemoResultsPage,
  loader: () => ({
    crumb: 'Processing Results',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesConvertWorkflowRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/convert',
  component: ConvertDataPageWorkflow,
  loader: () => ({
    crumb: 'Convert Data',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesReportsIndexRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/reports',
  component: RebateReportsIndexPage,
  loader: () => ({
    crumb: 'Reports',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesDivisionSummaryRoute = createRoute({
  getParentRoute: () => rebatesReportsIndexRoute,
  path: 'division-summary',
  component: DivisionRebateSummaryPage,
  loader: () => ({
    crumb: 'Division Rebate Summary',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesSupplierTagSummaryRoute = createRoute({
  getParentRoute: () => rebatesReportsIndexRoute,
  path: 'supplier-tag-summary',
  component: SupplierTagReportPage,
  loader: () => ({
    crumb: 'Supplier Tag Summary',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesDailyEarningsPYERoute = createRoute({
  getParentRoute: () => rebatesReportsIndexRoute,
  path: 'daily-earnings-pye',
  component: DailyEarningsPYEPage,
  loader: () => ({
    crumb: 'Daily Earnings PYE',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesMonthlyTrendingRoute = createRoute({
  getParentRoute: () => rebatesReportsIndexRoute,
  path: 'monthly-trending',
  component: MonthlyTrendingPage,
  loader: () => ({
    crumb: 'Monthly Trending',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesSupplierPaymentTermsRoute = createRoute({
  getParentRoute: () => rebatesReportsIndexRoute,
  path: 'supplier-payment-terms',
  component: SupplierPaymentTermsPage,
  loader: () => ({
    crumb: 'Supplier Payment Terms',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesProfitabilityReportRoute = createRoute({
  getParentRoute: () => rebatesReportsIndexRoute,
  path: 'profitability',
  component: ProfitabilityReportPage,
  loader: () => ({
    crumb: 'Profitability Report',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesTempReportRoute = createRoute({
  getParentRoute: () => rebatesReportsIndexRoute,
  path: 'temp',
  component: TempReportPage,
  loader: () => ({
    crumb: 'Custom Report',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rebatesDataExportRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rebates/data-export',
  component: RebateDataExportPage,
  loader: () => ({
    crumb: 'Data Export',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const priceQuoteSheetDashboardRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/price-sheet-dashboard',
  component: PriceQuoteSheetDashboard,
  loader: () => ({
    crumb: 'Price Sheet Dashboard',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});

const priceQuoteSheetDashboardDetailRoute = createRoute({
  getParentRoute: () => priceQuoteSheetDashboardRoute,
  path: '/detail/$quoteSheetId',
  component: PriceQuoteSheetDashboardDetailRoute,
});

const priceQuoteSheetInboxRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/price-sheet-inbox',
  component: PriceQuoteSheetInboxPage,
  loader: () => ({
    crumb: 'Price Sheet Inbox',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});

const priceQuoteSheetInboxDetailRoute = createRoute({
  getParentRoute: () => priceQuoteSheetInboxRoute,
  path: '/$quoteSheetId',
  component: PriceQuoteSheetInboxDetailRoute,
});

const apInvoicesRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/invoices',
  component: InvoicesPage,
  loader: () => ({
    crumb: 'Invoices',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
  },
  validateSearch: z.object({
    invoiceNumber: z.string().optional(),
    supplierId: z.string().optional(),
    status: z.array(z.string()).optional(),
    paymentStatus: z.array(z.string()).optional(),
    invoiceDateFrom: z.string().optional(),
    invoiceDateTo: z.string().optional(),
    dueDateFrom: z.string().optional(),
    dueDateTo: z.string().optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
});

const apInvoiceDetailRoute = createRoute({
  getParentRoute: () => apInvoicesRoute,
  path: '/$invoiceId',
  component: InvoiceDetailRoute,
  loader: async ({ context, params }) => {
    const { queryClient } = context;

    const invoice = await queryClient.ensureQueryData(
      orpc.accountsPayable.invoices.get.queryOptions({
        input: { id: params.invoiceId },
      }),
    );

    const crumb = invoice?.invoice?.invoiceNumber
      ? `Invoice: ${invoice.invoice.invoiceNumber}`
      : 'Invoice';
    return { crumb };
  },
});

const apPurchaseOrdersRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/purchase-orders',
  component: PurchaseOrdersPage,
  loader: () => ({
    crumb: 'Purchase Orders',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
  },
  validateSearch: z.object({
    externalId: z.string().optional(),
    supplierId: z.string().optional(),
    status: z.array(z.string()).optional(),
    orderDateFrom: z.string().optional(),
    orderDateTo: z.string().optional(),
    deliveryDateFrom: z.string().optional(),
    deliveryDateTo: z.string().optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
});

const apPaymentsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/payments',
  component: PaymentsPage,
  loader: () => ({
    crumb: 'Payments & Transactions',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
  },
  validateSearch: z.object({
    tab: z.enum(['payments', 'transactions']).optional(),
    status: z.string().optional(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
  }),
});

const apPurchaseOrderDetailRoute = createRoute({
  getParentRoute: () => apPurchaseOrdersRoute,
  path: '/$purchaseOrderId',
  component: PurchaseOrderDetailRoute,
});

const apPaymentDetailRoute = createRoute({
  getParentRoute: () => apPaymentsRoute,
  path: '/$paymentId',
  component: PaymentDetailRoute,
});

const divisionsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/divisions',
  component: DivisionsPage,
  loader: () => ({
    crumb: 'Divisions',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const divisionRoute = createRoute({
  getParentRoute: () => divisionsRoute,
  path: '$divisionId',
  component: DivisionDetailPage,
  loader: async ({ params, context }) => {
    // Fetch division data for breadcrumb using queryClient for caching
    const { queryClient } = context;
    const queryKey = [`organization/divisions/${params.divisionId}`];

    try {
      // Use queryClient.fetchQuery to leverage caching
      const response = await queryClient.fetchQuery({
        queryKey,
        queryFn: async () => {
          const fetchResponse = await fetch(
            `${config.apiBaseUrl}/organization/divisions/${params.divisionId}`,
            { credentials: 'include' },
          );

          if (!fetchResponse.ok) {
            throw new Error('Failed to fetch division');
          }

          const data = await fetchResponse.json();
          return data.data;
        },
      });

      return {
        crumb: response?.division?.name || 'Division Details',
      };
    } catch (error) {
      // Silently handle error - fallback to default
    }

    return {
      crumb: 'Division Details',
    };
  },
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const inboundEmailsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/inbound-emails',
  component: InboundEmailsPage,
  loader: () => ({
    crumb: 'Inbound Emails',
  }),
  validateSearch: z.object({
    page: z.number().optional(),
    pageSize: z.number().optional(),
    inboundEmailId: z.string().optional(),
  }),
});

const inboundEmailRulesRoute = createRoute({
  getParentRoute: () => inboundEmailsRoute,
  path: '/email-rules',
  component: InboundEmailRulesPage,
  loader: () => ({
    crumb: 'Email Rules',
  }),
  beforeLoad: ({ context }) => {
    const { auth } = context;
    if (!auth.currentUser?.isAdmin) {
      throw redirect({ to: '/inbound-emails' });
    }
  },
});

const documentsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/documents',
  component: DocumentsPage,
  loader: () => ({
    crumb: 'Documents',
  }),
});

const documentRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/documents/$documentId',
  component: DocumentDetailPage,
});

const settingsOrganizationRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/settings/organization',
  component: SettingsOrganizationPage,
  loader: () => ({
    crumb: 'Organization Settings',
  }),
  validateSearch: z.object({
    section: z.string().optional(),
  }),
});

const featureFlagsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ff_overrides',
  component: FeatureFlagsPage,
  loader: () => ({
    crumb: 'Feature Flags (INTERNAL)',
  }),
  beforeLoad: ({ context }) => {
    const { auth } = context;
    if (!auth.currentUser?.isAdmin) {
      throw redirect({
        to: '/',
      });
    }
  },
});

const historicalImportRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/admin/historical-import',
  component: HistoricalImportPage,
  loader: () => ({
    crumb: 'Historical Import',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});

const rexelMonitoringRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/rexel-monitoring',
  component: RexelMonitoringPage,
  loader: () => ({
    crumb: 'Rexel Monitor',
  }),
});

const oathAzureFlowCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/oauth-azure-callback',
  component: AzureOauthFlowCallback,
  validateSearch: z.object({
    code: z.string().optional(),
    error: z.string().optional(),
    error_description: z.string().optional(),
  }),
});

const qaRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/qa',
  component: QAPage,
});

const statusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/status',
  component: StatusPage,
});

const portalLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/portal/$portalId/login',
  component: PortalLoginPage,
});

const portalInviteAcceptRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/portal/invite/$token',
  component: PortalInviteAcceptPage,
});

const portalWelcomeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/portal/welcome',
  component: PortalWelcomePage,
});

const portalLoginRoute2 = createRoute({
  getParentRoute: () => rootRoute,
  path: '/portal/login',
  component: GlobalPortalLoginPage,
});

const portalContentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/portal/$portalId/view',
  component: PortalContentPage,
});

const shipAndDebitDashboardRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit',
  component: ShipAndDebitDashboard,
  loader: () => ({
    crumb: 'Ship and Debit',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
  },
});

const shipAndDebitVDMsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/vdm',
  component: VDMsPage,
  loader: () => ({
    crumb: 'VDMs',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
  },
  validateSearch: z.object({
    status: z.array(z.string()).optional(),
    supplierId: z.string().optional(),
    companyCode: z.string().optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
});

const shipAndDebit844And849Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/844-and-849',
  component: ShipAndDebit844sPage,
  loader: () => ({
    crumb: '844s & 849s',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
  },
  validateSearch: z.object({
    tab: z.enum(['pending', 'accepted', 'rejected']).optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
});

// 1) Layout parent: shows in matches, provides breadcrumb, renders WorkflowsPage with tabs
const workflowsListLayoutRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/workflows',
  component: WorkflowsPage,
  loader: () => ({
    crumb: 'Workflows',
  }),
  beforeLoad: ({ context }) => {
    const { auth } = context;
    if (!auth.currentUser?.isAdmin) {
      throw redirect({
        to: '/',
      });
    }
  },
});

const workflowDefinitionsTabRoute = createRoute({
  getParentRoute: () => workflowsListLayoutRoute,
  path: '/',
  component: WorkflowDefinitionsTab,
});

// Templates tab (renders at /workflows/templates)
const workflowTemplatesRoute = createRoute({
  getParentRoute: () => workflowsListLayoutRoute,
  path: 'templates',
  component: WorkflowTemplatesPage,
  loader: () => ({
    crumb: 'Templates',
  }),
});

// Playground tab (renders at /workflows/playground)
const workflowPlaygroundRoute = createRoute({
  getParentRoute: () => workflowsListLayoutRoute,
  path: 'playground',
  component: WorkflowPlaygroundPage,
  loader: () => ({
    crumb: 'Playground',
  }),
  beforeLoad: ({ context }) => {
    const { auth } = context;
    if (!auth.currentUser?.isAdmin) {
      throw redirect({
        to: '/',
      });
    }
  },
});

// Workflow definition layout route (sibling to workflowsLayoutRoute, not child)
const workflowDefinitionLayoutRoute = createRoute({
  getParentRoute: () => workflowsListLayoutRoute,
  path: '/$workflowDefinitionId',
  component: WorkflowDefinitionLayoutPage,
  loader: async ({ context, params }) => {
    // Skip fetching for create mode
    if (params.workflowDefinitionId === 'new') {
      return {
        crumb: 'New Workflow',
      };
    }

    const { queryClient } = context;

    const definition = await queryClient.ensureQueryData(
      orpc.workflows.getDefinition.queryOptions({
        input: {
          workflowDefinitionId: params.workflowDefinitionId,
        },
      }),
    );

    const crumb = definition?.name
      ? `Workflow: ${definition?.name}`
      : 'Workflow Definition';
    return {
      crumb,
    };
  },
  beforeLoad: ({ context }) => {
    const { auth } = context;
    if (!auth.currentUser?.isAdmin) {
      throw redirect({
        to: '/',
      });
    }
  },
});

// Workflow definition overview tab (default index)
const workflowDefinitionOverviewRoute = createRoute({
  getParentRoute: () => workflowDefinitionLayoutRoute,
  path: '/',
  component: WorkflowDefinitionOverviewTab,
  validateSearch: z.object({
    edit: z.boolean().optional(),
    emailRuleOptionId: z.string().uuid().optional(),
  }),
});

// Workflow definition steps tab
const workflowDefinitionStepsRoute = createRoute({
  getParentRoute: () => workflowDefinitionLayoutRoute,
  path: '/steps',
  component: WorkflowDefinitionStepsTab,
  loader: () => ({
    crumb: 'Steps',
  }),
});

// Workflow definition runs tab
const workflowDefinitionRunsRoute = createRoute({
  getParentRoute: () => workflowDefinitionLayoutRoute,
  path: '/runs',
  component: WorkflowDefinitionRunsTab,
  loader: () => ({
    crumb: 'Runs',
  }),
});

const agentsListLayoutRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/agents',
  component: AgentBuildersPage,
  loader: () => ({
    crumb: 'Agents',
  }),
  beforeLoad: ({ context }) => {
    const { auth } = context;
    if (!auth.currentUser?.isAdmin) {
      throw redirect({
        to: '/',
      });
    }
  },
});

const agentDefinitionsTabRoute = createRoute({
  getParentRoute: () => agentsListLayoutRoute,
  path: '/',
  component: AgentBuilderDefinitionsTab,
});

const agentDetailRoute = createRoute({
  getParentRoute: () => agentsListLayoutRoute,
  path: '/$agentId',
  component: AgentBuilderDetailLayoutPage,
  loader: ({ params }) => {
    if (params.agentId === 'new') {
      return {
        crumb: 'New Agent',
      };
    }
    return {
      crumb: 'Agent Details',
    };
  },
  beforeLoad: ({ context }) => {
    const { auth } = context;
    if (!auth.currentUser?.isAdmin) {
      throw redirect({
        to: '/',
      });
    }
  },
});

const customerProductMatchesRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/customer-product-matches',
  component: CustomerProductMatchesPage,
  loader: () => ({
    crumb: 'Customer Product Matches',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

const discountsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/discounts',
  component: DiscountsPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    sku?: string;
    customerId?: string;
    customerName?: string;
  } => ({
    sku: typeof search.sku === 'string' ? search.sku : undefined,
    customerId:
      typeof search.customerId === 'string' ? search.customerId : undefined,
    customerName:
      typeof search.customerName === 'string' ? search.customerName : undefined,
  }),
  loader: () => ({
    crumb: 'Discounts',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

// AR Overview page
const arOverviewRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ar/overview',
  component: AROverviewPage,
  loader: () => ({
    crumb: 'AR Overview',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

// AR Collections page
const arCollectionsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ar/collections',
  component: ARCollectionsPage,
  loader: () => ({
    crumb: 'Collections',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

// AR Invoices page
const arInvoicesRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ar/invoices',
  component: ARInvoicesPage,
  loader: () => ({
    crumb: 'AR Invoices',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

// AR Aging Report page
const arAgingReportRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ar/aging-report',
  component: ARAgingReportPage,
  loader: () => ({
    crumb: 'AR Aging Report',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

// AR Reconciliation page
const arReconciliationRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ar/reconciliation',
  component: ARReconciliationPage,
  loader: () => ({
    crumb: 'AR Reconciliation',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

// Customer Collections page
const customerCollectionsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ar/collections/$customerId',
  component: CustomerCollectionsPage,
  loader: () => ({
    crumb: 'Customer Collections',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});

// Shared report page (accessed via shareable links)
const sharedReportRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/shared/$token',
  component: SharedReportPage,
  loader: () => ({
    crumb: 'Shared Report',
  }),
});

// Shared links management page
const sharedLinksRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/shared-links',
  component: SharedLinksPage,
  loader: () => ({
    crumb: 'Shared Links',
  }),
  validateSearch: z.object({
    tab: z.enum(['my-links', 'shared-with-me']).optional().prefault('my-links'),
  }),
});

const homeRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/home',
  component: HomePage,
  loader: () => ({
    crumb: 'Home',
  }),
});

// Allocations Route
const allocationsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/allocations',
  component: AllocationsPage,
  loader: () => ({
    crumb: 'Allocations',
  }),
});

// Procurement Demo Routes
const procurementDemoDashboardRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo',
  component: ProcurementDemoDashboard,
  loader: () => ({
    crumb: 'Dashboard',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
});

const procurementDemoAgentsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/ai-workflows',
  component: ProcurementDemoAgentsPage,
  loader: () => ({
    crumb: 'Procurement Agents',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
  validateSearch: z.object({
    status: z.enum(['running', 'completed', 'failed', 'cancelled']).optional(),
  }),
});

const procurementDemoAgentDetailsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/ai-workflows/$agentId',
  component: ProcurementDemoAgentDetailsPage,
  loader: () => ({
    crumb: 'Agent Details',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
});

const procurementDemoPlanRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/procurement-plan',
  component: ProcurementDemoPlanPage,
  loader: () => ({
    crumb: 'Plan Procurement',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
});

const procurementDemoSuppliersRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/suppliers',
  component: ProcurementDemoSuppliersPage,
  loader: () => ({
    crumb: 'Suppliers',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
});

const procurementDemoItemsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/items',
  component: ProcurementDemoItemsPage,
  loader: () => ({
    crumb: 'Supplier Catalog',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
});

const procurementDemoSpendingAnalyticsRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/spending-analytics',
  component: ProcurementDemoSpendingAnalyticsPage,
  loader: () => ({
    crumb: 'Spending Analytics',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
});

const procurementDemoPurchaseOrdersRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/purchase-orders',
  component: ProcurementDemoPurchaseOrdersPage,
  loader: () => ({
    crumb: 'Purchase Orders',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
  validateSearch: z.object({
    supplierId: z.string().optional(),
    showAiOrder: z.coerce.string().optional(),
  }),
});

const procurementDemoInventoryRoute = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement-demo/inventory',
  component: ProcurementDemoInventoryPage,
  loader: () => ({
    crumb: 'Inventory Planning',
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT_DEMO],
    });
  },
});

export const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  portalLoginRoute,
  portalLoginRoute2,
  portalInviteAcceptRoute,
  portalWelcomeRoute,
  portalContentRoute,
  workosCallbackRoute,
  qaRoute,
  statusRoute,
  pathlessAuthenticatedRoute.addChildren([
    homeRoute,
    customersRoute,
    portalsRoute,
    portalDetailRoute,
    salesOrdersRoute,
    salesOrderRoute,
    salesOrderDraftRoute,
    salesOrderDraftExtractionViewerRoute,
    suppliersRoute,
    supplierDetailRoute,
    companiesRoute.addChildren([companyDetailRoute]),
    invoiceDemosRoute, // TODO remove this demo route
    rebateSupplierDetailRoute,
    emailPOMetricsRoute,
    famousEDIRoute,
    famousEDIShipmentsRoute.addChildren([famousEDIShipmentDetailRoute]),
    // rebatesSubmittedRoute,
    rebatesForecastingRoute,
    rebatesDebtorsRoute,
    rebatesTierProximityRoute,
    rebatesReportsIndexRoute.addChildren([
      rebatesDivisionSummaryRoute,
      rebatesSupplierTagSummaryRoute,
      rebatesDailyEarningsPYERoute,
      rebatesMonthlyTrendingRoute,
      rebatesSupplierPaymentTermsRoute,
      rebatesProfitabilityReportRoute,
      rebatesTempReportRoute,
    ]),
    rebatesDataExportRoute,
    // rebatesReconciliationRoute,
    rebatesAgreementsRoute.addChildren([
      rebatesAgreementLayoutRoute.addChildren([
        rebatesAgreementIndexRoute,
        rebatesAgreementSlugRoute,
        rebatesAgreementCreateVersionRoute,
        rebateCalculationAuditRoute,
      ]),
    ]),
    rebatesSupplierCollectionsRoute,
    rebatesSupplierReportedAmountsRoute,
    rebatesUploadDataRoute,
    rebatesUploadDataAIRoute,
    rebatesUploadDataManualRoute,
    rebatesUploadDataEmailQueueRoute,
    rebatesUploadDataDemoResultsRoute,
    rebatesConvertWorkflowRoute,
    priceQuoteSheetDashboardRoute.addChildren([
      priceQuoteSheetDashboardDetailRoute,
    ]),
    priceQuoteSheetInboxRoute.addChildren([priceQuoteSheetInboxDetailRoute]),
    apInvoicesRoute.addChildren([apInvoiceDetailRoute]),
    apPurchaseOrdersRoute.addChildren([apPurchaseOrderDetailRoute]),
    apPaymentsRoute.addChildren([apPaymentDetailRoute]),
    divisionsRoute.addChildren([divisionRoute]),
    inboundEmailsRoute.addChildren([inboundEmailRulesRoute]),
    documentsRoute,
    documentRoute,
    settingsOrganizationRoute,
    featureFlagsRoute,
    historicalImportRoute,
    rexelMonitoringRoute,
    oathAzureFlowCallbackRoute,
    shipAndDebitDashboardRoute,
    shipAndDebitVDMsRoute,
    shipAndDebit844And849Route,
    allocationsRoute,
    procurementDemoDashboardRoute,
    procurementDemoAgentsRoute,
    procurementDemoAgentDetailsRoute,
    procurementDemoPlanRoute,
    procurementDemoInventoryRoute,
    procurementDemoSuppliersRoute,
    procurementDemoItemsRoute,
    procurementDemoSpendingAnalyticsRoute,
    procurementDemoPurchaseOrdersRoute,
    memoryBankNotesRoute,
    integrationsListRoute,
    integrationDetailRoute,
    workflowsListLayoutRoute.addChildren([
      workflowDefinitionsTabRoute,
      workflowTemplatesRoute,
      workflowPlaygroundRoute,
      workflowDefinitionLayoutRoute.addChildren([
        workflowDefinitionOverviewRoute,
        workflowDefinitionStepsRoute,
        workflowDefinitionRunsRoute,
      ]),
    ]),
    agentsListLayoutRoute.addChildren([
      agentDefinitionsTabRoute,
      agentDetailRoute,
    ]),

    customerProductMatchesRoute,
    discountsRoute,
    arOverviewRoute,
    arInvoicesRoute,
    arCollectionsRoute,
    arAgingReportRoute,
    arReconciliationRoute,
    customerCollectionsRoute,
    sharedReportRoute,
    sharedLinksRoute,
  ]),
]);

export default routes;
